import { Todo } from 'api/clients/TodoClient'
import { ReactComponent as CancelIcon } from 'assets/icons/close16.svg'
import { ReactComponent as PostIcon } from 'assets/icons/post16.svg'
import cx from 'classnames'
import { IconButton } from 'components/IconButton/IconButton'
import { TodoForm } from 'components/TodoForm/TodoForm'
import { observer } from 'mobx-react-lite'
import { type EditorView } from 'prosemirror-view'
import { PRIORITY_EDITOR } from 'proseShared/constants'
import { useEffect, useRef } from 'react'
import Foco from 'react-foco'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import store from 'redux/store'
import { type DocStore } from 'stores/DocStore'
import Styles from './CreateTodoPrompt.module.scss'
import { createTodoSubmit } from './createTodoSubmit'

interface Props {
  view: EditorView
  onCreate: (todo: Todo) => void
  onCancel: () => void
  queryClient: QueryClient
  docStore: DocStore
  withPopoverStyles?: boolean
}

export const CreateTodoPrompt = observer(
  ({ view, onCreate, onCancel, queryClient, docStore, withPopoverStyles }: Props) => {
    const { from, to } = view.state.selection
    const titleInputRef = useRef<EditorView | null>(null)

    useEffect(() => {
      setTimeout(() => titleInputRef.current?.focus(), 100)
    }, [])

    const handleSubmit = createTodoSubmit(from, to, docStore, onCreate)

    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Foco onClickOutside={onCancel}>
            <div
              className={cx(Styles.container, PRIORITY_EDITOR, { [Styles.popover]: withPopoverStyles })}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <TodoForm
                showCheckbox
                titleInputRef={titleInputRef}
                initialValues={{
                  title: '',
                  htmlTitle: '',
                  description: '',
                  htmlDescription: '',
                  assignee: null,
                  dueDate: null,
                }}
                onSubmit={handleSubmit}
                onCancel={onCancel}
                primaryCta={<IconButton variant="primary" title="Post" icon={PostIcon} />}
                secondaryCta={<IconButton variant="tertiary" title="Cancel" icon={CancelIcon} isDisabled={false} />}
              />
            </div>
          </Foco>
        </QueryClientProvider>
      </Provider>
    )
  },
)
